var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesChatBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 827,
    height: 332,
    viewBox: "0 0 827 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2004_274)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 827,
    height: 332,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_2004_274)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.4072,
    cy: 108.342,
    rx: 82.4072,
    ry: 108.342,
    transform: "matrix(0.801396 0.598134 -0.849216 0.528046 492.001 35)",
    fill: "#E66D72"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter1_f_2004_274)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.99,
    cy: 133.861,
    rx: 90.0914,
    ry: 61.3897,
    fill: "#FFFC32"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2004_274",
    x: 116.136,
    y: -170.654,
    width: 699.799,
    height: 624.307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 118.319,
    result: "effect1_foregroundBlur_2004_274"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2004_274",
    x: -0.242813,
    y: -145.67,
    width: 616.466,
    height: 559.063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 109.071,
    result: "effect1_foregroundBlur_2004_274"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2004_274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 827,
    height: 332,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesChatBg);
export default __webpack_public_path__ + "static/media/salesChatBg.52d9a48812405e97e43c860c68884bcf.svg";
export { ForwardRef as ReactComponent };